import React from 'react';

import { Card } from '@ergeon/core-components';

import { Breadcrumbs, Logo, UserMenu } from './ui';

const Header: React.FC = () => {
  return (
    <Card
      className="flex justify-between items-center gap-4 px-4 py-2"
      flavor="transparent"
      rounded="none"
      tag="header"
      zIndex="2">
      <div className="flex justify-center items-center gap-1">
        <Logo />
        <Breadcrumbs />
      </div>
      <UserMenu />
    </Card>
  );
};

export default Header;
